import React, { useEffect, useState } from 'react';
import { db } from '../services/firebase';
import { collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

function getTableParam() {
  const params = new URLSearchParams(window.location.search);
  return params.get('table') || '';
}

const statusColor = status => {
  if (status === 'paid') return '#27ae60';
  if (status === 'completed') return '#2980b9';
  if (status === 'canceled') return '#e74c3c';
  return '#f39c12';
};

const CustomerOrderPage = () => {
  const [orders, setOrders] = useState([]);
  const [input, setInput] = useState('');
  const [error, setError] = useState('');
  const tableNumber = getTableParam();
  const navigate = useNavigate();
  const isMobile = window.innerWidth < 700;

  useEffect(() => {
    // Always fetch all orders, filter in JS for flexibility
    const q = query(collection(db, 'orders'), orderBy('createdAt', 'desc'));
    const unsub = onSnapshot(q, snap => {
      const list = [];
      snap.forEach(doc => list.push({ id: doc.id, ...doc.data() }));
      setOrders(list);
  
    });
    return () => unsub();
  }, [tableNumber]);

  // Helper to match table number flexibly
  const matchesTable = (orderTable, inputTable) => {
    if (!orderTable || !inputTable) return false;
    return String(orderTable).trim().toLowerCase() === String(inputTable).trim().toLowerCase();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input.trim()) {
      navigate(`/customer/menu?table=${encodeURIComponent(input.trim())}`);
    }
  };

  if (!tableNumber) {
    return (
      <div style={{ minHeight: '100vh', background: '#f4f6fa', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: isMobile ? 10 : 0 }}>
        <form onSubmit={handleSubmit} style={{ background: '#fff', borderRadius: 18, boxShadow: '0 8px 40px #2221', padding: isMobile ? 22 : 44, maxWidth: 380, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {/* Icon */}
          <div style={{ marginBottom: 18 }}>
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none"><rect x="3" y="7" width="18" height="13" rx="3" fill="#f4f6fa" stroke="#222" strokeWidth="2.2"/><rect x="7" y="3" width="10" height="6" rx="2" fill="#fff" stroke="#222" strokeWidth="2.2"/></svg>
          </div>
          <h2 style={{ fontWeight: 900, fontSize: isMobile ? 22 : 28, margin: 0, color: '#222', letterSpacing: 0.5, marginBottom: 18, textAlign: 'center' }}>Enter Your Table Number</h2>
          <input
            type="text"
            value={input}
            onChange={e => { setInput(e.target.value); setError(''); }}
            placeholder="e.g. 5"
            style={{
              width: '100%',
              fontSize: isMobile ? 18 : 22,
              padding: isMobile ? '12px 14px' : '16px 20px',
              borderRadius: 10,
              border: '2px solid #e0e0e0',
              marginBottom: 22,
              outline: 'none',
              boxShadow: '0 2px 8px #e0e0e022',
              textAlign: 'center',
              fontWeight: 700,
              background: '#fafbfc',
              transition: 'border 0.18s',
            }}
          />
          <button
            type="submit"
            style={{
              width: '100%',
              maxWidth: 220,
              background: '#222',
              color: '#fff',
              border: 'none',
              borderRadius: 10,
              fontWeight: 900,
              fontSize: isMobile ? 18 : 22,
              padding: isMobile ? '12px 0' : '16px 0',
              boxShadow: '0 2px 12px #e0e0e022',
              letterSpacing: 1,
              cursor: input.trim() ? 'pointer' : 'not-allowed',
              opacity: input.trim() ? 1 : 0.7,
              marginTop: 6,
              transition: 'background 0.18s',
            }}
            disabled={!input.trim()}
          >
            View Menu
          </button>
        </form>
      </div>
    );
  }
  // If tableNumber is present, redirect to /customer/menu?table=...
  window.location.href = `/customer/menu?table=${encodeURIComponent(tableNumber)}`;
  return null;
};

export default CustomerOrderPage; 